const SAFE_PAYMENT_WEB_DOMAINS = [
  'midtrans.com',
  'xendit.co',
  'gopay.co.id',
  'gojek.com',
  'gojek.link',
  'shopeepay.co.id',
  'airpay.co.id',
  'ovo.id',
  'dana.id',
]

const SAFE_LOCAL_PAYMENT_HOSTS = new Set([
  'localhost',
  '127.0.0.1',
  '::1',
])

const SAFE_PAYMENT_ACTION_PROTOCOLS = new Set([
  'gojek:',
  'shopeepay:',
  'ovo:',
  'dana:',
])

export function getSafePaymentActionUrl(value: string | null | undefined): string | null {
  const trimmed = value?.trim()
  if (!trimmed) return null

  try {
    const parsed = new URL(trimmed)
    if (parsed.protocol === 'https:') {
      return isTrustedPaymentWebHost(parsed.hostname) ? trimmed : null
    }
    if (parsed.protocol === 'http:') {
      return import.meta.env.DEV && SAFE_LOCAL_PAYMENT_HOSTS.has(parsed.hostname.toLowerCase()) ? trimmed : null
    }
    return SAFE_PAYMENT_ACTION_PROTOCOLS.has(parsed.protocol) ? trimmed : null
  } catch {
    return null
  }
}

function isTrustedPaymentWebHost(hostname: string): boolean {
  const normalized = hostname.toLowerCase()
  return SAFE_PAYMENT_WEB_DOMAINS.some((domain) => normalized === domain || normalized.endsWith(`.${domain}`))
}
